type BoatLineProps = {
  className?: string;
  /** Line colour class applied to strokes, defaults to currentColor via text-*. */
  title?: string;
};

/**
 * Technical line-art sailboat, drawn like a mark on a nautical chart.
 * Strokes use non-scaling widths so the drawing stays hairline at any size.
 */
export function BoatLine({ className = "", title }: BoatLineProps) {
  return (
    <svg
      viewBox="0 0 120 104"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none">
        {/* hull */}
        <path d="M20 74h80l-9 14q-31 7-62 0Z" vectorEffect="non-scaling-stroke" />
        {/* mast */}
        <path d="M62 74V14" vectorEffect="non-scaling-stroke" />
        {/* main sail */}
        <path d="M58 22q-17 22-24 46h24Z" vectorEffect="non-scaling-stroke" />
        {/* jib */}
        <path d="M66 30q16 18 22 38H66Z" vectorEffect="non-scaling-stroke" />
        {/* waterline */}
        <path d="M10 98q7-5 14 0t14 0 14 0 14 0 14 0 14 0 14 0" vectorEffect="non-scaling-stroke" opacity="0.55" />
      </g>
      {/* pennant */}
      <path d="M62 13.5l13 3.5-13 3.5Z" className="fill-signal" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
